export default "__VITE_ASSET__olMYuK4P__"